import React, { useState } from "react";
import "./login.css";
import { FaRegEyeSlash, FaRegEye } from "react-icons/fa";
import { Link } from "react-router-dom";
import logo from "../assests/logo.png";
import { useLocation } from "react-router-dom";
import group from "../assests/group.png";

const LoginForm = ({ formik, isLoading, error, forget_password_link = "" }) => {
  const [showPassword, setShowPassword] = useState(false);
  const location = useLocation();

  return (
    <form onSubmit={formik.handleSubmit} className="login_main">
      <div className="d-flex gap-2 align-items-center mb-5">
        <img
          src={logo}
          alt=""
          className=""
          style={{ width: "2.3rem", height: "auto" }}
        />
        <div
          className={`login_company_logo  d-flex justify-content-center flex-column `}
        >
          <p className="mb-0">University </p>
          <p className="mb-0">Intelligence</p>
        </div>
      </div>

      <div id="login_card">
        <div className="login_container">
          <p id="login_heading">
            <span>Welcome</span>!
          </p>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">
              Email
            </label>
            <input
              type="email"
              className="form-control input"
              id="email"
              placeholder="Email"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
            />
            {formik.touched.email && formik.errors.email ? (
              <div className="text-danger">{formik.errors.email}</div>
            ) : null}
          </div>

          <div className="mb-2">
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <div className="d-flex justify-content-center align-items-center position-relative">
              <input
                type={showPassword ? "text" : "password"}
                className="form-control input"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.password}
                id="password"
                placeholder="Enter your password "
              />
              <span
                className=" eye_btn "
                onClick={() => {
                  setShowPassword((prev) => !prev);
                }}
              >
                {!showPassword ? <FaRegEyeSlash /> : <FaRegEye />}
              </span>
            </div>
            {formik.touched.password && formik.errors.password ? (
              <div className="text-danger">{formik.errors.password}</div>
            ) : null}
          </div>
          <Link className="d-flex w-50  mb-4 " to={forget_password_link}>
            <p className="forget_password fw-bold mb-0  ">Forgot password?</p>
          </Link>

          <button
            type="submit"
            disabled={isLoading}
            className="btn btn-dark d-flex gap-2 justify-content-center align-items-center w-100 login_btn"
          >
            {isLoading ? "Processing..." : "Log In"}
            <div>
              <img
                src={group}
                style={{ height: "10px", width: "14px" }}
                alt=""
                srcSet=""
              />
            </div>
          </button>
          {error && (
            <p className="mb-0 mt-2 text-center text-danger">{error}</p>
          )}
        </div>

        {!location.pathname.startsWith("/super_admin/login") ? (
          <>
            <p id="bottom_text" className="text-center pb-3 pt-2 ">
              New to University Intelligence? <Link to="/client/signup">Create an account</Link>
            </p>
          </>
        ) : (
          <p id="bottom_text" className="text-center pb-3 pt-2 "></p>
        )}
      </div>
    </form>
  );
};

export default LoginForm;
